import { Component, OnInit } from '@angular/core';
import {Order, Referral} from '../../../dto/order';
import {byNumeric} from 'iso-country-codes';
import {PrevNextModel} from '../../../models/prev-next-model';
import {IdentStatus, ReferralStatus, WebIdTransactionProvider} from '../../../dto/ident-status';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {
  formatPhoneNumeric,
  phoneToCountry,
  toCardExpireDateString,
  toDateString,
  toDateTimeString
} from '../../../providers/app-date-adapter';
import {PrevNextIdModel} from '../../../models/prev-next-id-model';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {DatePipe, Location} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {RoleService} from '../../../services/role.service';
import {EventLogService} from '../../../services/crud/event-log.service';
import {ToastService} from 'angular-toastify';
import {ReferralsService} from '../../services/referrals.service';
import {CustomersService} from '../../services/customers.service';
import {Customer} from '../../../dto/customer';
import {CustomerRisk} from '../../../dto/customer-risk';
import {CityInfo} from '../../../dto/GeoIp/city-info';
import {Card} from '../../../dto/card';
import {Observable} from 'rxjs';
import {CardsService} from '../../services/cards.service';
import {OrdersBadgeService} from "../../services/orders-badge.service";

@Component({
  selector: 'app-referral-view',
  templateUrl: './referral-view.component.html',
  styleUrls: ['./referral-view.component.css']
})
export class ReferralViewComponent implements OnInit {

  referral: Referral;
  referralId: number;
  prevNext: PrevNextModel;
  loadingReferral: boolean;


  referralStatus = ReferralStatus;


  fields = [
    { header: 'Referrer', link: (row: Referral) => '../../customers-overview/' + row.customerId, cell: (row: Referral) => `${row.customer.firstName} ${row.customer.lastName}` } as ContentRowField<Referral>,
    { header: 'Referee', link: (row: Referral) => '../../customers-overview/' + row.refereeCustomerId, cell: row => {
        if ( !this.referee ) {
return '';
}
        return `${this.referee?.firstName} ${this.referee?.lastName}`;
      }
    } as ContentRowField<Referral>,
    { header: 'Status', cell: (row: Referral) => {

        if ( row.status == 1 ) {
return 'Referral accepted by referee';
}
        if ( row.status == 2 ) {
return 'Ordered';
}
        if ( row.status == 3 ) {
return 'Pending bonus';
}
        if ( row.status == 4 ) {
return 'Completed';
}

        if ( row.status == 9 ) {
return 'Expired';
}

      } } as ContentRowField<Referral>,
    { header: 'Transactions', cell: (row: Referral) => `${row.numberOfTransactions}/${row.targetNumberOfTransactions}` } as ContentRowField<Referral>,
    { header: 'Loads', cell: (row: Referral) => `${row.numberOfLoads}/${row.targetNumberOfLoads}` } as ContentRowField<Referral>,
    { header: 'Identified', cell: (row: Referral) => `${row.identified}` } as ContentRowField<Referral>,
    { header: 'Ordered', cell: (row: Referral) => `${row.ordered}` } as ContentRowField<Referral>,
    { header: 'Phone', cell: (row: Referral) => `+${row.phoneNumber}` } as ContentRowField<Referral>,
    { header: 'Expires',  cell: row => `${toDateString(row.expireDate)}`} as ContentRowField<Referral>,

  ];

  fieldsCustomer= [

    { header: 'Link', icon: (row) => 'visibility', link: (row) => '../../customers-overview/' + (row.id || ''), cell: (row) => `Customer` } as ContentRowField<Customer>,
    { header: 'Name', cell: (row) => `${row.title} ${row.firstName} ${row.lastName}` } as ContentRowField<Customer>,
    { header: 'DOB', cell: (row) => `${toDateString(row.dob) || ''}` } as ContentRowField<Customer>,
    { header: 'Address', cellFlag: (row) => byNumeric[row.countryIsoCode.toString().padStart(3, '0')].alpha2, cell: (row) => `${row.address || ''}, ${row.zipCode || ''} ${row.city || ''}, ${row.countryName || ''}` } as ContentRowField<Customer>,
    { header: 'Email', cell: (row) => `${row.email || ''}` } as ContentRowField<Customer>,
    { header: 'Mobile', cell: (row) => `+${row.phone || ''}` } as ContentRowField<Customer>,


    {header: 'IP Address'
      , cell: (row: Customer) => {
        const ret = row.ipAddress || '';
        return ret;

      }},

  ]  as ContentRowField<Customer>[];

  fieldsCard = [
    { header: 'Card name', cell: (row: Card) => `${row.cardName || ''}` },
    { header: 'Status', cell: (row: Card) => `${row.statusName || ''}` },
    { header: 'Exp date', cell: (row: Card) => `${toCardExpireDateString(row.expireDate) || ''}` },
    { header: 'Token', cell: (row: Card) => `${row.token}` },
    { header: 'Product', cell: (row: Card) => `${row.productName}` },
    { header: 'Creation Date', cell: (row: Card) => `${toDateTimeString(row.creationDate) || ''}` },
    { header: 'Activation date', cell: (row: Card) => `${toDateTimeString(row.activationDate) || ''}` },
    { header: 'Order date', cell: (row: Card) => `${toDateString(row.orderDate) || ''}` },
    // <a route_to_page search_string information_to_display
    { header: 'PAN'      , cell: (row: Card) => `${row.maskedPAN || '(unknown)' }` },
    { header: 'Card Type', cell: (row: Card) => `${row.cardTypeName || '(unknown)'}`},
  ] as ContentRowField<Card>[];





  prevNextIds: PrevNextIdModel;
  loadingPrevNext = false;
  loadingPrev = false;
  loadingNext = false;
  public loadingReferrer: boolean;
  public referrer: Customer|null;
  public referee: Customer|null;
  public loadingReferee: boolean;
  public refereeCards: Card[] = [];
  public referrerCards: Card[] = [];
  public isPayingBonus = false;



  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private referralsService: ReferralsService,
    private ordersBadgeService: OrdersBadgeService,
    private dialog: MatDialog,

    public roleService: RoleService,
    private logService: EventLogService,
    private datePipe: DatePipe,
    private _toastService: ToastService,
    private customersService: CustomersService,
    private cardsService: CardsService,

  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.referralId = idParam;
      this.clearData();
      this.initComponent(idParam);

    });

  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }


  initComponent(orderId: number) {

    this.getReferralData(orderId);

  }
  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  returnBack() {
    this.location.back();
  }




  getReferrerData() {
    this.loadingReferrer = true;
    this.customersService.get(this.referral.customerId)
      .subscribe(result => {
        this.referrer = result;
        this.getCustomerCards(this.referrer.id).subscribe(data => {
          this.referrerCards = data;
        });
        this.loadingReferrer = false;
      });

  }

  getCustomerCards(customerId: number): Observable<Card[]> {
    return this.cardsService.getForCustomer(customerId);
  }

  getRefereeData() {
    if ( !this.referral.refereeCustomerId ) {
return;
}

    this.loadingReferee = true;

    this.customersService.get(this.referral.refereeCustomerId)
      .subscribe(result => {
        this.referee = result;

      this.getCustomerCards(this.referee.id).subscribe(data => {
          this.refereeCards = data;
        });
        this.loadingReferee = false;
      });
  }

  getReferralData(referralId: number) {
    this.loadingReferral = true;
    this.referralsService.get(referralId)
      .subscribe(result => {
        this.referral = result;
        this.loadingReferral = false;
        this.ordersBadgeService.clearCache();

        this.getRefereeData();
        this.getReferrerData();

      }, error => {
        this._toastService.error('Unable to load referral: ' + error.message);
      });
  }


  clearData() {
    this.prevNext = null;
  }


  protected readonly ReferralStatus = ReferralStatus;

  payoutBonus() {
    this.isPayingBonus = true;
    try {
      this.referralsService.payBonus(this.referral.id).subscribe(value => {
        this._toastService.success('Bonus was paid');
        this.ordersBadgeService.clearCache();
        this.getReferralData(this.referralId);
      });
    } finally {
      this.isPayingBonus = false;
    }
  }
}
